const { Button } = require("reactstrap");

module.exports = {
  filter: {
    Equal: { Name: "Equal", Value: "eq" },
    Not_Equal: { Name: "Not Equal", Value: "neq" },
    Contain: { Name: "Contain", Value: "cont" },
    Not_Contain: { Name: "Not Contain", Value: "ncont" },
    Greater_Than: { Name: "Greater Than", Value: "gt" },
    Greater_Than_Equal_To: { Name: "Greater Than or Equal", Value: "gte" },
    Less_Than: { Name: "Less Than", Value: "lt" },
    Less_Than_Equal_To: { Name: "Less Than or Equal", Value: "lte" },
  },
  searchType: {
    Select: "select",
    Text: "text",
    Hidden: "hidden",
    DateTime: "datetime-local",
    Number: "number",
    Date: "date",
    Dropdown: "dropdown",
  },
  paginationType: {
    LAZY_LOADER: "LAZY",
    PAGINATION: "PAGINATION",
  },
  tableDataType: {
    BUTTON: "Button",
    ICON: "icon",
    TEXT: "text",
  },
  sortingOrder: {
    ASC: "asc",
    DESC: "desc",
  },
  customFilter: {
    FUTURE_INTERVIEWS: "FUTURE_INTERVIEWS",
  },
};
